module.exports = __webpack_public_path__ + "static/stunners-appointments-f540f8af62bf10d03b8101f3103f9706.png";